import { buttoBaseStyle } from '@screens/lp-default/styles';
import styled from 'styled-components';

export const HeroContainer = styled.section`
  position: relative;
  height: 450px;
  overflow: hidden;
  @media only screen and (min-width: 1024px) {
    height: 715px;
    align-content: center;
  }
`;

export const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  background: linear-gradient(270deg, rgba(79, 79, 79, 0) 34.73%, rgba(8, 8, 8, 0.35) 57.8%);
`;

export const HeroBackground = styled.picture`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  height: 100%;
  & img {
    min-height: 100%;
    width: 100%;
    object-fit: cover;
  }
  @media only screen and (min-width: 1024px) {
    display: none;
  }
`;

export const HeroVideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 50%;
  z-index: -2;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, 0%);

  @media only screen and (max-width: 1023px) {
    display: none;
  }
`;

export const HeroContent = styled.div`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.accent};
  box-sizing: border-box;
  max-width: 251px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[4]};
  margin-left: ${({ theme }) => theme.elsie.dimension[20]};
  margin-top: 35px;
  @media only screen and (min-width: 664px) {
    max-width: 416px;
    margin-left: ${({ theme }) => theme.elsie.dimension[24]};
    margin-top: ${({ theme }) => theme.elsie.dimension[40]};
  }
  @media only screen and (min-width: 1024px) {
    max-width: 588px;
    margin-top: 0;
    margin-left: 60px;
    padding: 0 ${({ theme }) => theme.elsie.dimension[20]};
  }
  @media only screen and (min-width: 1320px) {
    margin-left: 60px;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 28px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  margin: 0;
  @media only screen and (min-width: 664px) {
    font-size: 36px;
  }
  @media only screen and (min-width: 1024px) {
    font-size: 48px;
  }
`;

export const HeroSubtitle = styled.h1<{ isDesktopExclusive?: boolean }>`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: -0.32px;
  margin: 0;
  display: ${({ isDesktopExclusive }) => isDesktopExclusive && 'none'};
  @media only screen and (min-width: 1024px) {
    display: block;
    font-size: 24px;
  }
`;

export const HeroButton = styled.button`
  ${buttoBaseStyle};
  width: max-content;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.default};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.accent};
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  padding: 10px ${({ theme }) => theme.elsie.dimension[16]};
  font-size: 15px;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  }
  &:active {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.pressed};
  }
  @media only screen and (min-width: 1024px) {
    padding: 13px ${({ theme }) => theme.elsie.dimension[16]};
    font-size: 17px;
    border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  }
`;
